import styled from "styled-components";
import Header from "../../common/header";
import { Link, useParams } from "react-router-dom";
import NavBar from "../../common/NavBar";
import { media } from "../../media";
import Layout from "../../common/Layout";
import { useEffect, useRef, useState } from "react";
import WriteForm from "./WriteForm";
import { useAuth } from "../../hooks/useAuth";
import { useAlbum } from "../../hooks/useAlbum";
import CardBone from "../../common/components/CardBone";
import Toggle from "../../common/components/Toggle";
import CardList from "../../common/components/CardList";

const Album = () => {
  const { user } = useAuth();
  const [errorMsg, setErrorMsg] = useState("");
  const { userDocs, getUserDocs, getMyVocalList } = useAlbum();
  const { id } = useParams();
  const [isActivated, setIsActivated] = useState(false);
  const onClickToggle = () => {
    setIsActivated((prev) => !prev);
  };

  const AlbumRef = useRef<HTMLDivElement>(null);
  const scrollToTop = () => {
    AlbumRef.current?.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    if (!user.uid) {
      setErrorMsg("로그인이 필요합니다");
    } else if (user.uid && !user.emailVerified) {
      setErrorMsg("이메일 인증이 필요합니다");
    } else {
      setErrorMsg("");
    }

    if (user.uid && !userDocs) {
      getUserDocs(user.uid, user.level);
    }
  }, [user]);

  useEffect(() => {
    scrollToTop();
  }, [id]);

  return (
    <Layout isMyAlbum={true}>
      <AlbumWrap ref={AlbumRef}>
        <Header />
        <NavBar name="Album" />
        {errorMsg !== "" && (
          <div className="ErrorMsgWrap">
            <p>
              <Link to="/admin/login">{errorMsg}</Link>
            </p>
          </div>
        )}
        {user.username && user.emailVerified && (
          <>
            <div className="CardWrap">
              {id ? (
                <div className="WriteFormWrap">
                  <WriteForm
                    currentDoc={
                      id ? userDocs?.find((e) => e.id === id) : undefined
                    }
                    vocalList={getMyVocalList()}
                  />
                </div>
              ) : userDocs ? (
                <div className="CardInner">
                  <div className="ToggleWrap">
                    <Toggle
                      isActivated={isActivated}
                      onClick={onClickToggle}
                      label={isActivated ? "PUBLIC" : "PRIVATE"}
                    />
                  </div>
                  {
                    <CardList
                      currentDocs={userDocs}
                      currentUid={user.uid}
                      handlePrev={() => {}}
                      isPrivate={!isActivated}
                    />
                  }
                </div>
              ) : (
                <div className="CardInner">
                  <CardBone />
                  <CardBone />
                  <CardBone />
                </div>
              )}
            </div>
          </>
        )}
        {/* {user.username && user.emailVerified && !id && (
          <h2 onClick={() => setIsOpen(true)}>SWIPE or CLICK</h2>
        )} */}
      </AlbumWrap>
    </Layout>
  );
};

export default Album;

const AlbumWrap = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  ${media.desktop`
    width: 393px;
  `}
  .ErrorMsgWrap {
    padding: 24px;
    p {
      a {
        font-size: 14px;
        font-family: gmarket-sans-medium;
        color: #f94646;
      }
    }
  }

  .CardWrap {
    /* margin-bottom: 120px; */

    .WriteFormWrap {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-bottom: 60px;
    }
    .CardInner {
      display: flex;
      flex-direction: column;
      gap: 10px;
      padding: 0px 0px 24px 36px;
      .ToggleWrap {
        margin-left: 220px;
      }
    }
  }
  h2 {
    cursor: pointer;
    ${media.desktop`
      display: none;
    `}
    width: fit-content;
    margin: 0 auto;
  }
`;
